import { Button } from '@mui/material';
import { SettingsIcon } from 'assets/icons';
import { OptimizationGroupParametersType } from 'domains/optimization-group/types';
import OptimizationParametersSidePanel from 'domains/optimization/OptimizationParametersSidePanel';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface OptimizationParametersButtonProps {
  data: OptimizationGroupParametersType;
  id: string;
  disabled?: boolean;
}

export function OptimizationParametersButton({
  data,
  id,
  disabled,
}: Readonly<OptimizationParametersButtonProps>): ReactElement<OptimizationParametersButtonProps> {
  const [t] = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        className="text-xs sm:text-sm"
        sx={{ borderColor: (theme: { palette: { primary: { main: string } } }) => theme.palette.primary.main }}
        color="primary"
        disabled={disabled}
        onClick={(event) => {
          setIsOpen(true);
          event.stopPropagation();
        }}
        data-testid="OptimizationParametersButton"
      >
        <SettingsIcon className="min-w-5" />
        <span className="ml-1 hidden sm:inline">{t('OPTIMIZATION_BUTTON_LABEL')}</span>
      </Button>
      <OptimizationParametersSidePanel data={data} id={id} open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
